import * as Loadable from 'react-loadable'

import fetchSearchResults, {
  onBeforeSearchPageView
} from '../../../common/actions/searchPage'
import { IPageComponent } from '../../../typings/pageComponent'
import LoadingCover from '../../components/loadingCover'

const SearchPageLoadableContainer = (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "searchPage" */ './searchPageContainer'),
  loading: LoadingCover,
  webpack: () => [require.resolveWeak('./searchPageContainer')],
  modules: ['./searchPageContainer']
}) as IPageComponent<any>

SearchPageLoadableContainer.loadData = ({
  store: { dispatch },
  location,
  apiUrlPrefix,
  routeMatch
}) => dispatch(fetchSearchResults(location, apiUrlPrefix, routeMatch))

SearchPageLoadableContainer.onBeforePageView = ({
  store,
  location,
  routeMatch,
  prevLocation
}) =>
  store.dispatch(onBeforeSearchPageView({ location, routeMatch, prevLocation }))

export default SearchPageLoadableContainer
